export const NO_PERMISSION = '301';
export const FUTURE_ACCOUNT_IDX = 1;
export const DOME_TRADING_ID = 'd-0000';

export const DefaultDimension = /*     */ 0b000000;
export const TradeDimension = /*     */ 0b000001;
export const RoiDimension = /*     */ 0b000010;
export const PnlDimension = /*     */ 0b000100;

export const DimensionMap: Map<number, RankingDimension> = new Map([
  [TradeDimension, { label: 'tradingVolumeRanking', value: 'TRADING_AMOUNT' }],
  [RoiDimension, { label: 'rioRanking', value: 'ROI' }],
  [PnlDimension, { label: 'pnlRanking', value: 'PNL' }],
]);

export enum PredictNavigate {
  'section1',
  'section2',
  'section3',
  'section4',
  'section5',
}
